import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ActionPermissions, CustomPermission } from '../../../@types';
import { isUserHasPermission } from '../../../configs/permissions';
import { useGetUserSystemPermissions } from '../../../queries/user-query';
import { AddService } from '../AddService';
import { UpdateService } from '../UpdateService';

export const AddEditService: React.FC = () => {
  const { id }: any = useParams();
  const [permissions, setPermissions] = useState<CustomPermission[] | null>(null);

  const getUserPermissionsQuery = useGetUserSystemPermissions();

  useEffect(() => {
    getUserPermissionsQuery.data && setPermissions(getUserPermissionsQuery.data);
  }, [getUserPermissionsQuery.data]);

  if (id === 'create' && isUserHasPermission(ActionPermissions.Service_Create, permissions)) {
    return <AddService />;
  } else if (isUserHasPermission(ActionPermissions.Service_Edit_View_Service, permissions)) {
    return <UpdateService />;
  } else {
    return null;
  }
};